{
  "auth": {
    "agree": "我同意",
    "createAccount": "创建账号",
    "createNewAccount": "创建新账号",
    "email": "电子邮箱",
    "login": "登录",
    "password": "密码",
    "recover_password": "恢复密码",
    "sign_up": "注册",
    "keep_logged_in": "保持登录",
    "termsOfUse": "使用条款",
    "reset_password": "重置密码"
  },
  "404": {
    "title": "此页面已去钓鱼",
    "text": "如果您觉得这不对，请给我们发送消息",
    "back_button": "返回仪表板"
  },
  "typography": {
    "primary": "主要文本样式",
    "secondary": "次要文本样式"
  },
  "dashboard": {
    "versions": "版本",
    "setupRemoteConnections": "设置远程连接",
    "currentVisitors": "当前访问者",
    "charts": {
      "trendyTrends": "流行趋势",
      "showInMoreDetail": "显示更多细节",
      "showInLessDetail": "显示较少细节",
      "loadingSpeed": "加载速度",
      "topContributors": "主要贡献者",
      "showNextFive": "显示接下来的五个",
      "commits": "提交"
    },
    "info": {
      "componentRichTheme": "组件丰富的主题",
      "completedPullRequests": "已完成的拉取请求",
      "users": "用户",
      "points": "点数",
      "units": "单位",
      "exploreGallery": "探索画廊",
      "viewLibrary": "查看库",
      "commits": "提交",
      "components": "组件",
      "teamMembers": "团队成员"
    },
    "tabs": {
      "overview": {
        "title": "概述",
        "built": "使用 Vue.js 框架构建",
        "free": "对所有人完全免费",
        "fresh": "新鲜和清新的设计",
        "mobile": "响应式且优化移动",
        "components": "大量有用的组件",
        "nojQuery": "完全不使用 jQuery"
      },
      "billingAddress": {
        "title": "账单地址",
        "personalInfo": "个人信息",
        "firstName": "名字 & 姓氏",
        "email": "电子邮箱",
        "address": "地址",
        "companyInfo": "公司信息",
        "city": "城市",
        "country": "国家",
        "infiniteConnections": "无限连接",
        "addConnection": "添加连接"
      },
      "bankDetails": {
        "title": "银行详情",
        "detailsFields": "详情字段",
        "bankName": "银行名称",
        "accountName": "账户名称",
        "sortCode": "排序代码",
        "accountNumber": "账号",
        "notes": "备注",
        "sendDetails": "发送详情"
      }
    },
    "navigationLayout": "导航布局",
    "topBarButton": "顶部按钮",
    "sideBarButton": "侧边按钮"
  },
  "language": {
    "brazilian_portuguese": "葡萄牙语",
    "english": "英语",
    "spanish": "西班牙语",
    "simplified_chinese": "简体中文",
    "persian": "波斯语"
  },
  "menu": {
    "auth": "授权",
    "buttons": "按钮",
    "timelines": "时间线",
    "dashboard": "仪表板",
    "billing": "销售",
    "login": "登录",
    "signUp": "注册",
    "preferences": "偏好",
    "payments": "支付",
    "pricing-plans": "定价计划",
    "login-singup": "登录/注册",
    "404": "404 页面",
    "faq": "常见问题解答",
    "clients": "客户",
    "sales": "销售",
    "finance": "财务",
    "financeDashboard": "财务仪表板",
    "financialReports": "财务报告",
    "activeUsers": "活跃用户",
    "staff": "员工",
    "invitations": "邀请",
    "setup": "设置",
    "items": "项目",
    "roles": "角色",
    "configurations": "配置",
    "procurement": "采购",
    "suppliers": "供应商",
    "expenses": "费用",
    "commissions": "佣金",
    "stockOut": "库存出库",
    "transfers": "调拨",
    "catalog": "目录",
    "products": "产品",
    "unitsOfMeasure": "计量单位",
    "servicesCatalog": "服务",
    "salesOrders": "销售订单",
    "invoices": "发票",
    "financeOverview": "概览",
    "financePayments": "付款",
    "transactions": "交易",
    "reports": "报表",
    "financeReports": "财务报表",
    "itemsReports": "商品",
    "usersAndRoles": "用户与角色",
    "systemUsers": "活跃用户",
    "rolesAndPermissions": "角色与权限",
    "settingsApplication": "设置",
    "companySettings": "公司设置"
  },
  "messages": {
    "all": "查看所有消息",
    "new": "来自 {name} 的新消息",
    "mark_as_read": "标记为已读"
  },
  "navbar": {
    "messageUs": "需要Web开发帮助吗？请联系我们。",
    "repository": "GitHub 仓库"
  },
  "notifications": {
    "all": "查看所有通知",
    "mark_as_read": "标为已读",
    "sentMessage": "{name} 给你发了一条消息",
    "uploadedZip": "{name} 上传了一个新的 Zip 文件 {type}",
    "startedTopic": "{name} 开始了一个新话题"
  },
  "user": {
    "language": "修改语言",
    "logout": "登出",
    "logout": "登出",
    "profile": "我的资料",
    "settings": "设置",
    "billing": "销售",
    "faq": "常见问题",
    "helpAndSupport": "帮助与支持",
    "projects": "项目",
    "account": "账户",
    "explore": "探索"
  },
  "treeView": {
    "basic": "基本型",
    "icons": "图标",
    "selectable": "可选择",
    "editable": "可编辑",
    "advanced": "高级"
  },
  "chat": {
    "title": "聊天"
  },
  "cards": {
    "cards": "卡片",
    "fixed": "固定的",
    "floating": "浮动的",
    "contentText": "独特的斑马条纹使它们成为人们最熟悉的动物之一。",
    "rowHeight": "行高",
    "title": {
      "dark": "暗色背景",
      "bright": "亮色卡片",
      "titleOnImageNoOverlay": "图像上的标题，但没有叠加",
      "normal": "标准卡",
      "overlayAndTextOnImage": "图像上有覆盖和文本的卡片",
      "stripeNoImage": "无图像条纹卡"
    },
    "button": {
      "main": "主要",
      "cancel": "取消"
    },
    "link": {
      "edit": "编辑",
      "setAsDefault": "设为默认",
      "delete": "删除",
      "traveling": "Traveling",
      "france": "法国",
      "review": "评论",
      "feedback": "反馈信息",
      "readFull": "阅读全文",
      "secondaryAction": "第二行为",
      "action1": "行为 1",
      "action2": "行为 2"
    }
  },
  "helpAndSupport": "帮助与支持",
  "aboutVuesticAdmin": "关于 Vuestic Admin",
  "search": {
    "placeholder": "搜索..."
  },
  "expense": {
    "tabs": {
      "expenses": "费用",
      "expenseItems": "费用项目",
      "expenseCategories": "费用类别"
    },
    "recordsPlaceholder": "费用记录将在后续更新中于此标签页提供。",
    "records": {
      "registrationHeading": "费用抬头",
      "referenceNumber": "参考编号",
      "expenseDate": "费用日期",
      "totalAmount": "总金额",
      "notes": "备注",
      "linesHeading": "费用明细行",
      "addLineHeading": "添加费用明细行",
      "linesEmptyState": "尚未添加费用明细。请使用上方表单添加。",
      "removeLineConfirmTitle": "删除明细行",
      "removeLineConfirmMessage": "确定要删除此费用明细行吗？",
      "removeLineConfirmOk": "删除",
      "linesCountSuffix": "行",
      "selectCategory": "选择类别",
      "selectExpenseItem": "选择费用项目",
      "validationSelectCategory": "请选择费用类别。",
      "validationSelectItem": "请选择费用项目。",
      "validationAmountRequired": "金额为必填项。",
      "validationAmountPositive": "金额必须大于零。",
      "validationDescriptionRequired": "说明为必填项。",
      "validationFixLine": "请先修正明细后再添加。",
      "addLine": "添加行",
      "submit": "提交费用",
      "submitConfirmTitle": "确认费用",
      "submitConfirmMessage": "是否提交总额为 {total}、包含 {count} 行的费用？",
      "submitConfirmOk": "提交费用",
      "expenseItem": "费用项目",
      "amount": "金额",
      "displayDetailed": "明细",
      "displaySummary": "汇总",
      "registerExpense": "登记费用",
      "search": "搜索",
      "filterExpenseNumber": "费用编号",
      "filterReferenceNumber": "参考编号",
      "filterStartDate": "开始日期",
      "filterEndDate": "结束日期",
      "applyFilters": "应用筛选",
      "clearFilters": "清除",
      "expenseNumber": "费用编号",
      "viewDetails": "查看详情",
      "resultsSuffix": "条结果。",
      "perPage": "每页",
      "listLoadFailed": "无法加载费用列表，请重试。",
      "listEmptySummary": "当前筛选条件下没有费用汇总记录。",
      "listEmptyDetailed": "当前筛选条件下没有费用明细行。",
      "saveFailed": "无法保存费用，请重试。",
      "noDetail": "没有可用的费用详情。"
    },
    "statusActive": "启用",
    "statusInactive": "停用",
    "yes": "是",
    "no": "否",
    "modal": {
      "createExpenseItem": "新建费用项目",
      "editExpenseItem": "编辑费用项目",
      "createExpenseCategory": "新建费用类别",
      "editExpenseCategory": "编辑费用类别",
      "registerExpense": "登记费用",
      "expenseLinesTitle": "费用明细行"
    },
    "columns": {
      "name": "名称",
      "code": "代码",
      "description": "说明",
      "status": "状态",
      "category": "类别",
      "defaultAmount": "默认金额",
      "item": "项目"
    },
    "form": {
      "expenseCategory": "费用类别",
      "name": "名称",
      "code": "代码",
      "defaultAmount": "默认金额",
      "description": "说明",
      "active": "启用",
      "save": "保存",
      "cancel": "取消"
    },
    "categoriesLoadFailed": "无法加载费用类别，请重试。",
    "itemsLoadFailed": "无法加载费用项目，请重试。",
    "validation": {
      "atLeastOneLine": "请至少添加一行费用明细。",
      "expenseDateRequired": "费用日期为必填项。",
      "expenseDateNotInFuture": "费用日期不能晚于今天。",
      "totalMustBePositive": "总金额必须大于零。"
    },
    "toasts": {
      "categoryCreated": "费用类别已成功创建",
      "categoryUpdated": "费用类别已成功更新",
      "categoryDeleted": "费用类别已成功删除",
      "itemCreated": "费用项目已成功创建",
      "itemUpdated": "费用项目已成功更新",
      "itemDeleted": "费用项目已成功删除",
      "expenseCreated": "费用已成功登记"
    }
  }
}
